<template>
    <div v-html="field.etiqueta" class="my-4 text-center text-h5 font-weight-bold"></div>
</template>

<script>
    export default {
        name: "Title",
        props: ['field']
    }
</script>

<style scoped>

</style>